import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { LocalDate } from '../../core/model/local-date';

export enum ChangeType {
  Adjustment = 0,
  Import = 1,
  Index = 2,
  PropertyTaxAdjustment = 3,
}

export class FeeChange extends ModelBase {
  changeType: string;
  changeTypeKind: ChangeType;
  performedAt: Date;
  changeFrom: LocalDate;
  changeValue: number;
  retroactive: boolean;
  retroactiveFrom: LocalDate;
  retroactiveTo: LocalDate;
  reverted: boolean;
  caption: string;
  webUserName: string;
  leaseRowChanges: {
    oldYearRent: Money;
    newYearRent: Money;
    difference: Money;
    percentageChange: number;
    retroactiveAmount: Money;
    leaseAgreementNumber: string;
    propertyNumberAndName: string;
    companyNumberAndName: string;
    tenantOneName: string;
    articleNumber: string;
    invoiceRowText: string;
    rentalObjectStreet: string;
    rentalObjectTypeName: string;
    indexClauseName: string;
    indexAddition: Money;
    baseYearRent: Money;
    indexShare: number;
    baseIndexYear: number;
  }[];
  templateRowChanges: {
    oldYearRent: Money;
    newYearRent: Money;
    difference: Money;
    rentalId: string;
    propertyNumberAndName: string;
    companyNumberAndName: string;
    articleNumber: string;
    invoiceRowText: string;
    rentalObjectStreet: string;
    rentalObjectTypeName: string;
    indexClauseName: string;
    indexAddition: Money;
    baseYearRent: Money;
    indexShare: number;
    baseIndexYear: number;
  }[];

  toJson() {
    return { id: this.id, caption: this.caption };
  }
}
